module.exports = __webpack_public_path__ + "static/img/home_showmore_photo3@2x.73d7fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/home_showmore_photo3@2x.png
// module id = iPIc
// module chunks = 0